import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import './DashboardLayout.css';
import logo from '../assets/company-logo.png';

function DashboardLayout({ user, setUser }) {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
    navigate('/');
  };

  const menus = {
    admin: [
      { name: 'Dashboard', path: '/dashboard/home' },
      { name: 'My Tasks', path: '/dashboard/mytasks' },
      { name: 'Hiring', path: '/dashboard/hiring' },
      { name: 'Manage Students', path: '/dashboard/manage-students' },
      { name: 'Manage Staff', path: '/dashboard/manage-staff' },
      { name: 'Clients', path: '/dashboard/clients' },
      { name: 'Syllabus', path: '/dashboard/syllabus-generation' },
      { name: 'Staff Attendance', path: '/dashboard/staff-attendance' },
      { name: 'Lead Management', path: '/dashboard/lead-management' },
      { name: 'Manage Tasks', path: '/dashboard/tasks' },
      { name: 'Expense Tracker', path: '/dashboard/expense-tracker' },
      { name: 'Manage Batches', path: '/dashboard/manage-batches' },
      { name: 'Manage Workshop Registrations', path: '/dashboard/workshop-registrations' },
      // { name: 'Send WhatsApp', path: '/dashboard/send-whatsapp' },
    ],
    staff: [
      { name: 'Dashboard', path: '/dashboard/staff-home' },
      { name: 'My Tasks', path: '/dashboard/mytasks' },
      { name: 'Hiring', path: '/dashboard/hiring' },
      { name: 'Billing', path: '/dashboard/billing' },
      { name: 'Petty Cash', path: '/dashboard/petty-cash' },
      { name: 'Admissions', path: '/dashboard/admission' },
      { name: 'Interns', path: '/dashboard/interns' },
      { name: 'Manage Students', path: '/dashboard/manage-students' },
      { name: 'Leave & Salary', path: '/dashboard/leave-salary' },
      { name: 'Leads', path: '/dashboard/leads' },
      { name: 'Manage Batches', path: '/dashboard/manage-batches' },
      { name: 'Manage Workshop Registrations', path: '/dashboard/workshop-registrations' },

    ],
    student: [
      { name: 'My Home', path: '/dashboard/student-home' },
      { name: 'Assignments', path: '/dashboard/assignments' },
    ],
  };

  const menuItems = menus[user?.role] || [];

  return (
    <div className="layout-wrapper">
  {/* Sidebar */}
  <aside className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
  {/* Mobile Toggle Button */}
  <button
    className="sidebar-toggle"
    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
    aria-label="Toggle sidebar"
  >
    ⋮
  </button>

  <div className="text-center mb-4">
    <img src={logo} alt="Company Logo" className="sidebar-logo" />
    <h5 className="mt-2">{user?.name?.toUpperCase()}</h5>
  </div>

  <nav className="menu">
    {menuItems.map((item) => (
      <NavLink
        key={item.name}
        to={item.path}
        className={({ isActive }) =>
          `menu-item ${isActive ? "active" : ""}`
        }
        onClick={() => setIsSidebarOpen(false)}
      >
        {item.name}
      </NavLink>
    ))}
  </nav>

  <div className="logout-section">
    <Button
      variant="outline-light"
      className="logout-btn"
      onClick={handleLogout}
    >
      Logout
    </Button>
  </div>
</aside>


  {/* Main Content */}
  <main className="content">
    {/* MOBILE TOGGLE BUTTON */}
    <button
      className="sidebar-toggle"
      onClick={() => setIsSidebarOpen(!isSidebarOpen)}
    >
      ⋮
    </button>

    <div className="content-inner">
      <Outlet />
    </div>
  </main>
</div>

  );
}

export default DashboardLayout;
